import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddPaymentComponent } from './add-payment/add-payment.component';
import { PaymentHistoryComponent } from './payment-history/payment-history.component';
import { PaymentListComponent } from './payment-list/payment-list.component';

const routes: Routes = [
  {
    path:'',
    children:[
      { path: '', redirectTo: "transaction-list", pathMatch: "full" },
      {
        path:'add-transaction',component:AddPaymentComponent
      },
      {
        path:'transaction-list' , component:PaymentListComponent
      },
      {
        path:'transaction-history/:id' , component:PaymentHistoryComponent
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PaymentRoutingModule { }
